/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TableQuery } from './tableQuery';


export interface TableJointure extends TableQuery { 
    fieldJoin?: string;
    fieldJoinOrg?: string;
    join?: Array<TableJointure>;
    joinType?: TableJointure.JoinTypeEnum;
    ownerPartner?: string;
    schema?: string;
    tableName: string;
}
export namespace TableJointure {
    export type JoinTypeEnum = 'LEFT_OUTER_JOIN' | 'INNER_JOIN' | 'RIGHT_OUTER_JOIN' | 'FULL_OUTER_JOIN' | 'NATURAL_JOIN' | 'CROSS_JOIN';
    export const JoinTypeEnum = {
        LEFTOUTERJOIN: 'LEFT_OUTER_JOIN' as JoinTypeEnum,
        INNERJOIN: 'INNER_JOIN' as JoinTypeEnum,
        RIGHTOUTERJOIN: 'RIGHT_OUTER_JOIN' as JoinTypeEnum,
        FULLOUTERJOIN: 'FULL_OUTER_JOIN' as JoinTypeEnum,
        NATURALJOIN: 'NATURAL_JOIN' as JoinTypeEnum,
        CROSSJOIN: 'CROSS_JOIN' as JoinTypeEnum
    };
}
